<template>
  <div class="CitationDetails">
    <div>
      <span class="highlight">{{ authorInformation }}</span>
      <span v-if="citation.year">{{ citation.year }}.</span>
      <em v-if="citation.title">{{ citation.title }}</em
      >.
      <span>{{ journalInformation }}.</span>
    </div>
    <v-row class="ma-0 py-3">
      <a
        :href="`https://doi.org/${citation.doi}`"
        target="_blank"
        rel="noopener"
      >
        CrossRef
        <span class="d-sr-only">{{ citation.doi }} [opens in a new tab]</span>
        <v-icon small color="primary" aria-hidden="true">{{
          mdiOpenInNew
        }}</v-icon>
      </a>
    </v-row>
    <v-divider />
  </div>
</template>

<script>
import { mdiOpenInNew } from "@mdi/js";
export default {
  name: "CitationDetails",
  props: { citation: { type: Object, default: () => {} } },
  data() {
    return {
      mdiOpenInNew,
    };
  },
  computed: {
    authorInformation() {
      const names = this.citation.authors.map((author) => {
        let name = "";

        if (author.family) {
          name += author.family;
        }
        if (author.given) {
          if (author.family) {
            name += ", ";
          }
          name += author.given;
        }

        return name;
      });
      const finalName = names.pop();
      return names.length ? names.join(", ") + " and " + finalName : finalName;
    },
    pageInformation() {
      const { fpage: firstPage, lpage: lastPage } = this.citation;

      let pageData = "";

      if (firstPage && lastPage) pageData += "pp. ";
      else pageData += "p. ";

      if (firstPage) pageData += firstPage;
      if (lastPage) pageData += `-${lastPage}`;

      return pageData;
    },
    journalInformation() {
      const { journalTitle, volume, issue } = this.citation;

      const information = [];

      if (journalTitle) information.push(journalTitle);
      if (volume) information.push(`Volume ${volume}`);
      if (issue) information.push(`Issue ${issue}`);
      if (this.pageInformation) information.push(this.pageInformation);

      return information.join(", ");
    },
  },
};
</script>
